export default "__VITE_ASSET__34b39616__"